import _ from 'lodash';
import { FC, ReactNode, useMemo } from 'react';

import { useLocalize } from '@treams/treams-hooks/useLocalize';
import * as graphql from '@treams/treams-network';

import { GrowthPathContext, useGrowthPathContext } from '../contexts/GrowthPathContext';
import { GrowthPathJobCompetency } from '../types';

type Props = {
	jobCompetencies: Array<Partial<GrowthPathJobCompetency>>;
	children: ReactNode;
	data?: graphql.UserCompetenciesQuery | graphql.JobTitleCompetenciesQuery;
};

const LabelQueryWrapper: FC<Props> = ({ jobCompetencies, children }) => {
	const { localize } = useLocalize();
	const context = useGrowthPathContext();

	const labels = useMemo(
		() =>
			_.sortBy(
				_.uniqBy(
					jobCompetencies
						.flatMap((jobCompetency) => jobCompetency.competency?.label)
						.filter(Boolean),
					'id',
				),
				(label) => localize(label!.title).text,
			),
		[jobCompetencies, localize],
	);

	const hasUnlabeled = jobCompetencies.some((jobCompetency) => !jobCompetency.competency?.label);

	const labelID =
		context.labelID === 'unlabeled' && hasUnlabeled
			? 'unlabeled'
			: (labels.find((label) => label!.id === context.labelID)?.id ?? labels[0]?.id ?? 'unlabeled');

	return (
		<GrowthPathContext.Provider value={{ ...context, labelID }}>
			{children}
		</GrowthPathContext.Provider>
	);
};
export default LabelQueryWrapper;
